/* eslint-disable no-console */
import axios from 'axios'
import { print } from 'graphql'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import dotenv from 'dotenv'
import { NotificationStore } from '@/components/vueblack/NotificationPlugin'
import { Session } from '@/plugins/session'
import { sentryErrors } from '@/plugins/sentryErrors'

dotenv.config()
const baseURL = () => process.env.NUXT_ENV_CONTA

const apiClient = axios.create({
  baseURL: baseURL(),
  method: 'post',
  headers: {
    Accept: '*/*',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
    'Content-Type': 'application/json'
  },
  timeout: 60000
})

apiClient.send = ({ query, variables }) => apiClient.post(baseURL(), { query: print(query), variables })

apiClient.interceptors.request.use(async request => {
  if (process.browser) NProgress.start()

  const userToken = await Session.getToken()

  if (userToken) request.headers.Authorization = `Bearer ${userToken}`

  return request
})

apiClient.interceptors.response.use(
  response => {
    if (process.browser) NProgress.done()

    if (response.data.errors) return errorHandler(response)

    return response
  },
  err => errorHandler(err)
)

const errorHandler = err => {
  if (process.browser) NProgress.done()
  const errorGetter = err.response || err.error || err
  // errores graphql
  if (errorGetter.data) {
    let logout = false
    const errArray = errorGetter.data.errors.reduce((arr, item) => {
      if (item.extensions.code === 'UNAUTHENTICATED') logout = true
      arr.push({
        type: 'danger',
        message: item.message || 'Error general de la aplicación :(',
        icon:
          item.extensions.code === 'UNAUTHENTICATED'
            ? 'fa fa-key'
            : item.extensions.code === 'BAD_USER_INPUT'
            ? 'fa fa-cloud-sun'
            : item.extensions.code === 'GRAPHQL_VALIDATION_FAILED'
            ? 'fa fa-cloud-sun-rain'
            : item.extensions.code === 'INTERNAL_SERVER_ERROR'
            ? 'fa fa-cloud-moon-rain'
            : 'fa fa-cloud-rain'
      })

      return arr
    }, [])

    console.error('contabilidad error errArray :>> ', errArray)
    sentryErrors(errArray, 'JIT Web - contabilidad API')

    NotificationStore.notify(errArray)

    if (logout)
      setTimeout(() => {
        Session.end()
      }, 3000)

    return Promise.reject(new Error('graphql intercepted error'))
  }

  // error de conexión con el servidor.
  if (err.message === 'Network Error') {
    NotificationStore.notify({
      type: 'danger',
      message: err.message,
      icon: 'fa fa-cloud-showers-heavy'
    })
    return Promise.reject(new Error('Network Error'))
  }

  // error no administrado.
  // eslint-disable-next-line no-console
  console.log(`no administrado `, err)
  NotificationStore.notify({
    type: 'danger',
    message: 'Esto no debería pasar, error no administrado :(',
    icon: 'fa fa-poo-storm'
  })

  return Promise.reject(new Error('graphql intercepted error'))
}

export default apiClient
